<template>
    <div class="hrm_input">
        <label class="hrm_input_label text-sm font-medium text-gray-800 dark:text-gray-400">{{
            trans("lang.labels.work_source") }}
        </label>
        <div class="relative mt-2">
            <VueMultiselect :key="componentKey" class="hrm-vuemultiselect hrm_input_field"
                v-model="filterData[filterItem.workSourceModel]" :options="filterItem.workSources" @select="onChangeWorkSource"
                @clear="onClearWorkSource" :placeholder="trans('lang.labels.Select')" label="name" valueProp="id"
                :searchable="true" />
        </div>
    </div>
    <div class="theme-input hrm_input">
        <label class="hrm_input_label text-sm font-medium text-gray-800 dark:text-gray-400">{{
            trans("lang.labels.work_profile") }}
        </label>
        <div class="relative mt-2">
            <VueMultiselect :key="componentKey" class="hrm-vuemultiselect" v-model="filterData[filterItem.workSourceProfileModel]"
                @clear="onClearWorkProfile" :options="filterItem.workSourcesProfiles"
                :placeholder="trans('lang.labels.Select')" label="name" valueProp="id" :searchable="true" />
        </div>
    </div>
</template>
<script setup>
import { onMounted, ref } from 'vue';
import VueMultiselect from "@vueform/multiselect";

const props = defineProps({
    filterItem: { type: Object },
    filterData: { type: Object, required: true },
});

const componentKey = ref(1)

const onChangeWorkSource = async () => {    
    await getWorkSourcesProfiles(props.filterData[props.filterItem.workSourceModel]);
}

const onClearWorkSource = () => {
    props.filterData[props.filterItem.workSourceModel] = null;
    props.filterData[props.filterItem.workSourceProfileModel] = null;
    props.filterItem.workSourcesProfiles = [];
    componentKey.value += 1;
}

const onClearWorkProfile = () => {
    props.filterData[props.filterItem.workSourceModel] = null;
}

const getWorkSources = async () => {
    try {
        const response = await axios.get(route("quote-manager.work-sources.index"));
        props.filterItem.workSources = [...response.data.data];
    } catch (error) {
        console.error("Error fetching work sources:", error);
    }
};

const getWorkSourcesProfiles = async (workSourceId) => {
    try {
        let query = {
            workSourceId: workSourceId
        }
        const response = await axios.get(route("quote-manager.work-source-profiles.index"), { params: query })
        props.filterItem.workSourcesProfiles = [...response.data.data];
    } catch (error) {
        console.error("Error fetching work sources profiles:", error);
    }
};

onMounted(async () => {
    if (props.filterItem.workSources && props.filterItem.workSources.length == 0) {
        await getWorkSources();
    }
    if (props.filterItem.workSourcesProfiles && props.filterItem.workSourcesProfiles.length == 0) {
        await getWorkSourcesProfiles();
    }
});


</script>